import store from '@/store'
import mock from '@/services/mock/index'
import { getDataAsTable } from '@/services/functions/getDataAsTable'

async function getInvoiceLines (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const testLines = mock.getInvoiceLines
        resolve(testLines)
      }, 500)
    })
  } else {
    if (!Object.keys(order.order || {}).length) {
      if (!order.order) {
        order.order = {}
      }
      order.order.lineNumber = true
    }
    var data = store.getters['invoicesIssuing/4/form']?.invoiceLines
    return getDataAsTable(data, order, params)
  }
}

export { getInvoiceLines }
